import { render } from "./Adminplan.vue?vue&type=template&id=7fab8f5f"
import script from "./Adminplan.vue?vue&type=script&lang=js"
export * from "./Adminplan.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__